import { about, glance, profile } from "../data";
import { Reveal, Section } from "./ui";

export function About() {
  return (
    <Section id="about" title="About me" intro="Who I am, where I've been, and what I'm looking for next.">
      <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr] lg:gap-16">
        <div className="max-w-[62ch] space-y-5">
          {about.map((paragraph, index) => (
            <Reveal key={index} delay={index * 0.08}>
              <p className="leading-relaxed text-mist">{paragraph}</p>
            </Reveal>
          ))}

          <Reveal delay={0.24}>
            <figure className="relative mt-10 border-l border-blush/40 pl-6">
              <blockquote className="text-display-italic text-[1.35rem] leading-snug text-porcelain/95 sm:text-[1.5rem]">
                Understand the problem first, keep the design small, and leave things clearer than I
                found them.
              </blockquote>
              <figcaption className="mt-3 text-[0.8rem] text-faint">
                How I try to work
              </figcaption>
            </figure>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="glass halo leaf p-7 sm:p-8">
            <p className="text-display text-[1.15rem] text-porcelain">At a glance</p>
            <dl className="mt-6 space-y-4">
              {glance.map((item) => (
                <div
                  key={item.label}
                  className="flex items-baseline justify-between gap-4 border-b border-white/[0.08] pb-3 last:border-b-0 last:pb-0"
                >
                  <dt className="text-[0.78rem] whitespace-nowrap text-faint">{item.label}</dt>
                  <dd className="text-right text-[0.86rem] text-porcelain/90">{item.value}</dd>
                </div>
              ))}
            </dl>

            <a
              href={`mailto:${profile.email}`}
              className="link-underline mt-7 inline-block text-[0.86rem] text-blush transition-colors hover:text-porcelain"
            >
              {profile.email}
            </a>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
